export const evaluatedOptions = {
  'last-60-minutes': 'Last 60 minutes',
  'last-24-hours': 'Last 24 hours',
  'last-7-days': 'Last 7 days',
  'last-14-days': 'Last 14 days',
  'last-30-days': 'Last 30 days',
  'last-60-days': 'Last 60 days',
};
